/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsFilm: {
  name: 'film';
  data: string;
} = {
  name: 'film',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M.5 2A1.5 1.5 0 0 1 2 .5h12A1.5 1.5 0 0 1 15.5 2v12a1.5 1.5 0 0 1-1.5 1.5H2A1.5 1.5 0 0 1 .5 14V2Zm1 10.5V14a.5.5 0 0 0 .5.5h1.5v-2h-2Zm2-1h-2v-3h2v3Zm1 .5v2.5h7v-13h-7V12Zm10-3.5v3h-2v-3h2Zm0 4h-2v2H14a.5.5 0 0 0 .5-.5v-1.5Zm-11-5h-2v-3h2v3Zm11-3v3h-2v-3h2Zm-11-1h-2V2a.5.5 0 0 1 .5-.5h1.5v2Zm11-1.5v1.5h-2v-2H14a.5.5 0 0 1 .5.5Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
